const cardioLectors = [12, 14]

const osteoporosisLectors = [11, 29, 34, 179]

const modernMethodsDmpLectors = [6, 546, 549, 548, 551, 550]

export { cardioLectors, osteoporosisLectors, modernMethodsDmpLectors }
